<div class="role-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <dx-popup
  #addUser
  [width]="600"
  [showTitle]="true"
  title="{{ modalTitle }}"
  [dragEnabled]="false"
  [closeOnOutsideClick]="false"
  [rtlEnabled]="rtlEnabled"
  [(visible)]="isOpened"
  (onShown)="onFieldDataChanged($event)">
    <dx-scroll-view width="100%" height="100%">

      <dx-form #roleForm
               id="roleForm"
               validationGroup="roleData"
               [showValidationSummary]="false"
               (onFieldDataChanged)="onFieldDataChanged($event)"
               colCount="auto"
               [(formData)]="model"
               [minColWidth]="500">
        <dxi-item itemType="tabbed">
          <dxi-tab title="{{ 'SHARED.GENERAL' | translate }}">
            <dxi-item 
            dataField="name"
                      [template]="'roleNameField'">
              <dxo-label text="{{ 'SHARED.NAME' | translate }}"></dxo-label>
              <dxi-validation-rule type="required" message="{{ 'SHARED.NAME' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="description"
                      [template]="'roleDescriptionField'">
              <dxo-label text="{{ 'SHARED.DESCRIPTION' | translate }}"></dxo-label>
              <dxi-validation-rule type="required" message="{{ 'SHARED.DESCRIPTION' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
            </dxi-item>
          </dxi-tab>
          <dxi-tab title="{{ 'ROLES.PERMISSIONS' | translate }}">
            <dx-list
                [items]="permissions"
                     [height]="400"
                     [showSelectionControls]="true"
                     [selectAllMode]="true"
                     selectionMode="all"
                     [(selectedItemKeys)]="requiredPermissions"
                     displayExpr="name"
                     keyExpr="platformPermissionId">
            </dx-list>
          </dxi-tab>
        </dxi-item>

        <div *dxTemplate="let data of 'roleNameField'">
          <translatable-field (change)="onChangeTranslationField($event, 'name')" [isDevExpress]="true" [isLabelHidden]="true" [caption]="'SHARED.NAME'" [(data)]="data.component.option('formData')[data.dataField]" [name]="'name'" #roleName></translatable-field>  
        </div>
        <div *dxTemplate="let data of 'roleDescriptionField'">
          <translatable-field (change)="onChangeTranslationField($event, 'description')" [isDevExpress]="true" [isLabelHidden]="true" [caption]="'SHARED.DESCRIPTION'"  [type]="'textbox'" [(data)]="data.component.option('formData')[data.dataField]" [name]="'description'" #roleDescription></translatable-field>  
        </div>
      </dx-form>
      <div class="au-dx-popup-padder">
        <button type="submit" class="btn btn-primary" (click)="onSubmit();" name="btnRoleSubmit" disabled="disabled">
      {{ 'SHARED.SAVE' | translate }}
        </button>
    <button type="button" class="btn btn-outline" (click)="onCancel();">{{ 'SHARED.CANCEL' | translate }}</button>
        </div>
    </dx-scroll-view>
  </dx-popup>
</div>
